import React from 'react'
import {
    useBusinessRequestItemsReport,
    useBusinessRequestReports,
    useRequestItemsApprovalDecisions,
} from 'hooks'
import useSubcomponents from 'useSubcomponents'
import ItemApproverDecisionsLayout from './ItemApproverDecisions/ItemApproverDecisionsLayout'
import BusinessRequestsLayout from './BusinessRequests/BusinessRequestsLayout'
import BusinessRequestItemsLayout from './BusinessRequestItems/BusinessRequestItemsLayout'

const allFilters = {
    itemApproverDecisions: [
        {
            name: 'approvedBy',
            requireAccess:
                'MyTasks-ItemApproverDecisionsApproverFilter-Control',
        },
        {
            name: 'subjectType',
            requireAccess:
                'MyTasks-ItemApproverDecisionRequestedForFilter-Control',
        },
        {
            name: 'itemTypeAction',
            requireAccess:
                'MyTasks-ItemApproverDecisionsItemTypeActionFilter-Control',
        },
        {
            name: 'participantType',
            requireAccess:
                'MyTasks-ItemApproverDecisionsParticipantTypeFilter-Control',
        },
        {
            name: 'approvalDecision',
            requireAccess:
                'MyTasks-ItemApproverDecisionsApprovalDecisionFilter-Control',
        },
        {
            name: 'approverDecisionStepStatus',
            requireAccess:
                'MyTasks-ItemApproverDecisionsStepStatusFilter-Control',
        },
        {
            name: 'approverDecisionItemStatus',
            requireAccess:
                'MyTasks-ItemApproverDecisionsItemStatusFilter-Control',
        },
        {
            name: 'approverDecisionRiskType',
            requireAccess:
                'MyTasks-ItemApproverDecisionsRiskTypeFilter-Control',
        },
        {
            name: 'approverDecisionRiskLevels',
            requireAccess:
                'MyTasks-ItemApproverDecisionsRiskLevelsFilter-Control',
        },
        {
            name: 'itemApproverDecisionsAdvancedSearch',
            requireAccess:
                'MyTasks-ItemApproverDecisionsAdvancedSearchFilter-Control',
        },
    ],
    businessRequests: [
        {
            name: 'initiatedBy',
            requireAccess:'MyTasks-BusinessRequestsInitiatorFilter-Control',
        },
        {
            name: 'businessRequestType',
            requireAccess: 'MyTasks-BusinessRequestTypeFilter-Control',
        },
        {
            name: 'requestedBy',
            requireAccess: 'MyTasks-BusinessRequestsRequestedByFilter-Control',
        },
        {
            name: 'subjectType',
            requireAccess: 'MyTasks-BusinessRequestsRequestedForFilter-Control',
        },
        {
            name: 'approver',
            requireAccess: 'MyTasks-BusinessRequestsApproverFilter-Control',
        },
        {
            name: 'preApproved',
            requireAccess: 'MyTasks-BusinessRequestsShowPreApprovedFilter-Control',
        },
        {
            name: 'requestStatus',
            requireAccess: 'MyTasks-BusinessRequestsRequestViewStatusFilter-Control',
        },
        {
            name: 'itemType',
            requireAccess: 'MyTasks-BusinessRequestsItemTypeFilter-Control',
        },
        {
            name: 'riskLevel',
            requireAccess: 'MyTasks-BusinessRequestsRiskLevelsFilter-Control',
        },
        {
            name: 'audit',
            requireAccess: 'MyTasks-BusinessRequestsAuditFilter-Control',
        },
        {
            name: 'requestItemsAdvancedSearch',
            requireAccess:
                'MyTasks-BusinessRequestsAdvancedSearchFilter-Control',
        },
    ],
    businessRequestItems: [
        {
            name: 'initiatedBy',
            requireAccess:
                'MyTasks-BusinessRequestItemsInitiatorFilter-Control',
        },
        {
            name: 'subjectType',
            requireAccess:
                'MyTasks-BusinessRequestItemsRequestedForFilter-Control',
        },
        {
            name: 'approvedBy',
            requireAccess: 'MyTasks-BusinessRequestItemsApproverFilter-Control',
        },
        {
            name: 'accessAssignee',
            requireAccess:
                'MyTasks-BusinessRequestItemsAccessAssigneeFilter-Control',
        },

        {
            name: 'itemTypeAction',
            requireAccess:
                'MyTasks-BusinessRequestItemsItemTypeActionFilter-Control',
        },
        {
            name: 'participantType',
            requireAccess:
                'MyTasks-BusinessRequestItemsParticipantTypeFilter-Control',
        },
        {
            name: 'approvalDecision',
            requireAccess:
                'MyTasks-BusinessRequestItemsApprovalDecisionFilter-Control',
        },

        {
            name: 'approverDecisionItemStatus',
            requireAccess:
                'MyTasks-BusinessRequestItemsItemStatusFilter-Control',
        },
        {
            name: 'fulfillmentStatus',
            requireAccess:
                'MyTasks-BusinessRequestItemsFulfillmentStatusFilter-Control',
        },
        {
            name: 'approverDecisionRiskLevels',
            requireAccess:
                'MyTasks-BusinessRequestItemsRiskLevelsFilter-Control',
        },
        {
            name: 'itemApproverDecisionsAdvancedSearch',
            requireAccess:
                'MyTasks-BusinessRequestItemsAdvancedSearchFilter-Control',
        },
    ],
}

const ItemApproverDecisionsReports = () => {
    const { list, totalCount, loading, loadingMore, pagination, refetch } =
        useRequestItemsApprovalDecisions()

    const { trimFiltersBasedOnAccess } = useSubcomponents()

    const filters = trimFiltersBasedOnAccess(
        allFilters.itemApproverDecisions,
    ).map((f) => f)

    return (
        <ItemApproverDecisionsLayout
            totalCount={totalCount}
            list={list}
            isLoading={loading}
            isLoadingMore={loadingMore}
            pagination={pagination}
            filters={filters}
            refetch={refetch}
            type={'myRequests'}
        />
    )
}
const BusinessRequestsReports = () => {
    const { list, totalCount, loading, loadingMore, pagination, refetch } =
        useBusinessRequestReports()

    const { trimFiltersBasedOnAccess } = useSubcomponents()

    const filters = trimFiltersBasedOnAccess(allFilters.businessRequests).map(
        (f) => f,
    )

    return (
        <BusinessRequestsLayout
            totalCount={totalCount}
            list={list}
            isLoading={loading}
            isLoadingMore={loadingMore}
            pagination={pagination}
            filters={filters}
            refetch={refetch}
            type={'myRequests'}
        />
    )
}
const BusinessRequestItemsReports = () => {
    const { list, totalCount, loading, loadingMore, pagination, refetch } =
        useBusinessRequestItemsReport()

    const { trimFiltersBasedOnAccess } = useSubcomponents()

    const filters = trimFiltersBasedOnAccess(
        allFilters.businessRequestItems,
    ).map((f) => f)

    return (
        <BusinessRequestItemsLayout
            totalCount={totalCount}
            list={list}
            isLoading={loading}
            isLoadingMore={loadingMore}
            pagination={pagination}
            filters={filters}
            refetch={refetch}
            type={'myRequests'}
        />
    )
}

export {
    ItemApproverDecisionsReports,
    BusinessRequestsReports,
    BusinessRequestItemsReports,
}